import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME, EXPORT_FILE_NAME } from './constants';

class StockAgingAnalysisProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	async GetWarehouse(Ids: any) {
		return this.fetch('/DropdownList/GetWarehouse/', { workshopId: Ids });
	}

	async GetFullStockAgingAnalysisReport(Parameters: any, columnsSeq: any, languageId: any) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/${NAME}/GetFullStockAgingAnalysisReport?${Parameters}&ColumnSequence=${columnsSeq}&LanguageId=${languageId}`, EXPORT_FILE_NAME);
	}
}
export const apiProvider = new StockAgingAnalysisProvider();
